import { BootstrapStoreProvider } from '../bootstrap-store-provider';

// This barrel file is temporary and allows PRs for implementation to not have diffs on `bootstrap-store-provider` to ensure safe PRs
export { type BootstrapContainerProps } from '../bootstrap-store-provider';
export default BootstrapStoreProvider;
